<template>
  <ul
    class="paginator uk-pagination uk-flex-center"
    uk-margin
    v-show="hasMultiplePages"
  >
    <li :class="{ 'uk-disabled': !hasPrevPage }" class="uk-margin-auto-right">
      <paginator-link
        :change-route="changeRoute"
        @change-page="changePage"
        :disabled="!hasPrevPage"
        :page="prevPage"
      >
        <span uk-pagination-previous class="uk-margin-small-right"></span>
        {{$t('previous')}}
      </paginator-link>
    </li>

    <li
      v-for="page in pages"
      :class="{
        'uk-active': page.value === currentPage,
        'uk-disabled': page.truncated
      }"
    >
      <span v-if="page.truncated">…</span>
      <paginator-link
        v-else
        :change-route="changeRoute"
        @change-page="changePage"
        :active="page.value === currentPage"
        :truncate="page.truncated"
        :page="page.value"
      >
        {{page.value}}
      </paginator-link>
    </li>

    <li :class="{ 'uk-disabled': !hasNextPage }" class="uk-margin-auto-left">
      <paginator-link
        :change-route="changeRoute"
        @change-page="changePage"
        :disabled="!hasNextPage"
        :page="nextPage"
      >
        {{$t('next')}}
        <span uk-pagination-next class="uk-margin-small-left"></span>
      </paginator-link>
    </li>
  </ul>
</template>

<script>
import PaginatorLink from '@/components/PaginatorLink';

export default {
  name: 'paginator',
  components: {
    PaginatorLink,
  },
  props: {
    pageInfo: {
      type: Object,
      default: () => ({ page: 1, size: 0, totalPages: 0 }),
    },
    offset: {
      type: Number,
      default: 4,
    },
    changeRoute: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    currentPage() {
      return this.pageInfo.page;
    },
    totalPages() {
      return this.pageInfo.totalPages;
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPrevPage() {
      return this.currentPage > 1;
    },
    prevPage() {
      return this.currentPage - 1;
    },
    nextPage() {
      return this.currentPage + 1;
    },
    pages() {
      const pages = [];
      for (let page = 1; page <= this.totalPages; page += 1) {
        if (this.renderPage(page)) {
          pages.push({ value: page, truncated: false });
        } else if (this.renderEllipsis(page)) {
          pages.push({ value: page, truncated: true });
        }
      }
      return pages;
    },
    hasMultiplePages() {
      return this.totalPages > 1;
    },
    rightOffset() {
      return (this.totalPages - this.offset) + 1;
    },
  },
  methods: {
    changePage(queryParams) {
      if (!this.changeRoute) {
        this.$emit('change-page', queryParams);
      }
    },
    renderPage(page) {
      const infixMin = this.currentPage - this.offset;
      const infixMax = this.currentPage + this.offset;
      return page <= this.offset ||
             page >= this.rightOffset ||
             (page >= infixMin && page <= infixMax);
    },
    renderEllipsis(page) {
      return page === this.offset + 1 || page === this.rightOffset - 1;
    },
  },
  i18n: {
    messages: {
      de: {
        previous: 'Zurück',
        next: 'Weiter',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// Paginator.vue?0738fa7a